module.exports = ".button-container {\n  float: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/personal-config/app-settings/app-settings.component.scss
// module id = ./src/app/personal-config/app-settings/app-settings.component.scss
// module chunks = main